import { useEffect } from "react";

import { serverGetUserInviteStatuses } from "api/api-server-data";
import { AppDispatch, useAppDispatch } from "store/index";
import { computedStateActions } from "store/slices/computed";

// Reusable function to fetch and store user invite statuses
export const fetchAndStoreUserInviteStatuses = async (dispatch: AppDispatch) => {
  try {
    const statuses = await serverGetUserInviteStatuses();
    dispatch(computedStateActions.saveUserInviteStatuses(statuses));
  } catch (error) {
    console.error("Failed to fetch user invite statuses:", error);
  }
};

// Fetches user invite statuses for the current org and stores them in the computed slice
export const useFetchUserInviteStatuses = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchAndStoreUserInviteStatuses(dispatch);
  }, [dispatch]);
};
